import { forTarget, hideElement, showElement } from '@core/content'

import * as ResultChart from './resultsChart'
import * as ResultTable from './resultsTable'

type Severity = 'normal' | 'mild' | 'moderate' | 'severe'

export const frequencyTiers = [250, 500, 1000, 2000, 4000, 8000]

export const displayChart = (root: RootElement) => {
  const form = document.getElementById('hearing-test-form')!
  const inputsLeft = Array.from(form.querySelectorAll<HTMLInputElement>('input[id^="L"]')!)
  const inputsRight = Array.from(form.querySelectorAll<HTMLInputElement>('input[id^="R"]')!)
  const inputsArrayLeft: number[] = inputsLeft.map((input) => parseInt(input.value))
  const inputsArrayRight: number[] = inputsRight.map((input) => parseInt(input.value))

  const resultsSummary: Record<Severity, HTMLElement> = {
    normal: forTarget<HTMLElement>(root, 'results-summary-normal')!,
    mild: forTarget<HTMLElement>(root, 'results-summary-mild')!,
    moderate: forTarget<HTMLElement>(root, 'results-summary-moderate')!,
    severe: forTarget<HTMLElement>(root, 'results-summary-severe')!,
  }

  const hideAllSummaries = () => {
    Object.values(resultsSummary).forEach((summary) => hideElement(summary))
  }

  const handleDisplayChanges = (db: number) => {
    hideAllSummaries()

    if (db <= 20) {
      showElement(resultsSummary.normal)
    } else {
      if (db <= 40) {
        showElement(resultsSummary.mild)
      } else if (db <= 60) {
        showElement(resultsSummary.moderate)
      } else {
        showElement(resultsSummary.severe)
      }
    }
  }

  const maxDbLeft = Math.max(...inputsArrayLeft)
  const maxDbRight = Math.max(...inputsArrayRight)
  const maxDbOverall = Math.max(maxDbLeft, maxDbRight)

  handleDisplayChanges(maxDbOverall)

  updateResultsData(inputsLeft, inputsRight)
  ResultChart.updateResultsChart(inputsArrayLeft, inputsArrayRight)
  ResultTable.updateResultsTable(inputsLeft, inputsRight, frequencyTiers)
}

const updateResultsData = (dataLeft: ArrayLike<HTMLInputElement>, dataRight: ArrayLike<HTMLInputElement>) => {
  const testResults: Record<string, { left: number; right: number }> = {}
  Array.from(dataLeft).forEach((dataPoint) => {
    const frequency = dataPoint.name.slice(2)
    testResults[frequency] = { left: parseInt(dataPoint.value), right: 20 }
  })
  Array.from(dataRight).forEach((dataPoint) => {
    const frequency = dataPoint.name.slice(2)
    testResults[frequency].right = parseInt(dataPoint.value)
  })

  localStorage.setItem('testResults', JSON.stringify(testResults))
}
